import {
    SPI,
    DialogViewActionWidget,
    ActionType,
    BaseActionWidget,
    PopupSubmitParameters,
    PushActiveRecordsPredict,
    ViewActionTarget,
    Widget,
    ObjectValue,
    getModel,
    REFRESH_FORM_DATA,
    WidgetSubjection
} from '@kunlun/dependencies';
import comp from './RetailScheduledTask.vue';
import { type IQueryTaskDetailItem, matchProductApi, type productItem } from './service';

@SPI.ClassFactory(
    BaseActionWidget.Token({
        actionType: [ActionType.View],
        target: [ViewActionTarget.Dialog],
        name: 'uiView713819b82668434081881e19be0f87b6',
        model: 'deli.retail.RetailItemScheduleTaskItemDetail'
    })
)
export class RetailScheduledTaskAction extends DialogViewActionWidget {
    initialize(props: any) {
        super.initialize(props);

        this.setComponent(comp);
        return this;
    }

    @Widget.Reactive()
    public get label() {
        return this.action.label ?? '添加创建商品';
    }
    @Widget.Reactive()
    public get disabled(): boolean {
        return !!this.action.disabled;
    }
    @Widget.Reactive()
    public get invisible(): boolean {
        //@ts-ignore
        return this?.rootData?.[0]?.taskType === 'CREATE';
    }



    @Widget.Reactive()
    public async validationAndFillFunction(code: string) {
        const variables: ObjectValue = { path: this.getDsl().sessionPath };
        return await matchProductApi({ code: code }, variables)

    }
    @Widget.SubContext(REFRESH_FORM_DATA)
    protected reloadFormData$!: WidgetSubjection<boolean>;

    @Widget.Reactive()
    public get itemDetailList() {
        return this.rootData?.[0]?.itemDetailList ?? [];
    }
    @Widget.Reactive()
    public setFormData(val: productItem[]) {

        if (Array.isArray(val)) {
            this.rootData![0].itemDetailList = val;
        }

        this.reloadFormData$.subject.next(true);
    }

}
